import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClientXml from "../../utils/HttpClientXml";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import Swal from "sweetalert2";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackPageBtn from "../BackButton/BackPageBtn";
import moment from "moment";

const customStyles = {
  rows: {
    style: {
      padding: "1em 0",
    },
  },
};

const ServicesNotes = () => {
  const location = useLocation();
  const user = location.state?.user;
  const assignedService = location.state?.assignedService;
  const assignedServiceName = location.state?.assignedServiceName;

  console.log("Amit Notes user", user);
  console.log("Amit Notes assignedService", assignedService);
  console.log("Amit Notes assignedServiceName", assignedServiceName);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [allData, setAllData] = useState();
  const [editId, setEditId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState();

  const [assignServiceFormDisplay, setAssignServiceFormDisplay] =
    useState(true);
  const [uploadDocumentFormDisplay, setUploadDocumentFormDisplay] =
    useState(false);

  const initValue = {
    serviceName: "",
    // documentation: selectedTypes
  };
  const [formValue, setFormValue] = useState(initValue);

  const fetchDocumentTypes = async (items) => {
    console.log("POI40", items);

    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data, items);
      if (response && response?.status) {
        setDocumentTypes(
          response.data.filter((doc) => items.includes(doc._id)),
        );
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const [allServices, setAllServices] = useState([]);
  const fetchServices = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllServices();
      console.log("WEX53", response.data);
      if (response && response?.status) {
        setAllServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  console.log("jhsgdfjhakd", editId);

  const [isEdit, setIsEdit] = useState(true);
  const [editData, setEditData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
  };

  const [assignService, setAssignService] = useState("");

  // submit
  const _handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("alldasdasdd", formValue);
    // return
    const { title, description } = formValue;
    const isValid = title.trim() !== "" && description.trim() !== "";

    if (isValid) {
      if (formValue?.image1 === "" || formValue?.image2 === "") {
        return toast.error("Please Upload Images");
      } else {
        const res = await HomeServices.addBlog(formValue);
        // console.log("resCat", res)
        if (res && res?.status) {
          toast.success("Blog Added Successfully");
          fetchData();

          // navigate('/manage-category');
          setIsLoading(false);
          console.log("formValue21456", formValue);
        } else {
          toast.error(res?.message || "Something Wrong");
          setIsLoading(false);
        }
      }
    } else {
      toast.error("Please Fill All The Inputs, Including the Image.");
    }
  };

  const [serviceForDocumentUpload, setServiceForDocumentUpload] = useState({
    serviceId: "",
    assignedServiceId: "",
  });
  const handleUploadDocumentForm = (e, item) => {
    e.preventDefault();
    console.log("TRE113", item);
    setServiceForDocumentUpload({
      serviceId: item?.ServiceData?._id,
      assignedServiceId: item._id,
    });
    fetchDocumentTypes(item?.ServiceData?.documentation);
    setAssignServiceFormDisplay(false);
    setUploadDocumentFormDisplay(true);
  };

  const columns = [
    // { name: "SL No.", selector: "sln", sortable: true },
    { name: "Date", selector: "date", wrap: true, width: "10%" },
    { name: "Note", selector: "note", wrap: true, width: "80%" },
    { name: "Given by", selector: "givenBy", wrap: true, width: "10%" },
    // { name: "Status", selector: "workStatus", wrap: true },
    // { name: "Action", selector: "action", wrap: true },
    // { name: "Note", selector: "note", wrap: true },
  ];

  const fetchData = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAssignedServicesByUser({
        userId: user?.userId,
      });
      console.log("SER86", response.data, assignedService);
      if (response && response?.status) {
        const allNotes = response?.data?.filter(
          (item) => item._id === assignedService,
        );
        console.log("HGF147", allNotes[0].serviceNotes);

        let arr = allNotes[0].serviceNotes?.reverse()?.map((ele, index) => {
          return {
            sln: index + 1,
            date: moment(ele?.createdAt).format("DD-MMM-YYYY"),
            note: ele?.note,
            givenBy: ele?.addedByAdminData?.name || ele?.addedByStaffData?.name,
            // workStatus: (
            //   <>
            //     <div>
            //       <select className="form-control"
            //       // value={}
            //       >
            //         <option value="">---Select---</option>
            //         <option>Working</option>
            //         <option>Ongoing</option>
            //         <option>Completed</option>
            //       </select>
            //     </div>
            //   </>
            // ),
            // action: (
            //   <>
            //     <div>
            //       <button className="btn btn-success btn-sm"
            //         onClick={(e) => handleUploadDocumentForm(e, ele)}
            //       >View/Upload Documents ({ele?.ServiceData?.documentation?.length})</button>
            //     </div>
            //   </>
            // ),
            // note: (
            //   <>
            //     <div>
            //       <button className="btn btn-success btn-sm"
            //         onClick={(e) => handleUploadDocumentForm(e, ele)}
            //       >View/Add Note ({ele?.ServiceData?.documentation?.length})</button>
            //     </div>
            //   </>
            // ),
          };
        });
        // console.log("HGF189",arr[0].ele.serviceNotes);

        setAllData(arr);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  useEffect(() => {
    // fetchDocumentTypes()
    // fetchServices()
    fetchData();
  }, []);

  // click on edit
  const handleEdit = (e, ele) => {
    e.preventDefault();
    console.log("FTY164", ele);

    window.scrollTo(0, 0);
    // setSelectedTypes(ele.documentation)
    setEditMode(true);
    setEditId(ele?._id);
    setFormValue({
      serviceName: ele.serviceName,
      documentation: ele.documentation,
    });
  };

  const handleDelete = async (id) => {
    console.log("deleteblogid", id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      console.log("result", result);
      if (result?.isConfirmed) {
        HomeServices.deleteService(id)
          .then((res) => {
            if (res && res.status) {
              toast.success("Deleted Successfully");
              fetchData();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((err) => {
            console.error("Error deleting document:", err);
          });
      } else {
        console.log("Deletion canceled");
      }
    });
  };

  // const handleCheckboxChange = (event) => {
  //   const { value, checked } = event.target;
  //   setSelectedTypes((prev) =>
  //     checked ? [...prev, value] : prev.filter((type) => type !== value)
  //   );
  // };

  const [note, setNote] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!note) return toast.error("Remarks should not be empty!");
    const formData = {
      assignedServiceId: assignedService,
      note: note,
    };
    console.log("VFE267", formData);
    //return

    await HomeServices.setNoteToAssignedService(formData)
      .then((res) => {
        if (res && res?.status) {
          toast.success("Remarks added successfully");
          setNote("");
          fetchData();
        } else {
          toast.error(res?.message || "Failed to Assign");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        console.error("err", err);
      });
  };

  // useEffect(() => {
  //   setFormValue({ ...formValue, documentation: selectedTypes })
  // }, [selectedTypes])

  return (
    <>
      <CustomLoader loading={isLoading} />
      <div className="d-flex justify-content-end mt-2">
        <div className="form-header">
          <BackPageBtn backLink="/users" />
        </div>
      </div>
      {assignServiceFormDisplay && (
        <div className="d-flex justify-content-end _mt-2">
          <div className="form-header">
            <section className="piechartsBox_area">
              <form>
                <div>
                  <h1
                    style={{
                      color: "#ff9c00",
                      fontSize: "25px",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    Service Note
                  </h1>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">
                      Remarks/Message
                    </label>

                    <textarea
                      className="form-control"
                      placeholder="Enter Service Name"
                      name="note"
                      value={note}
                      onChange={(e) => {
                        setNote(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div class="col-12 ">
                  <button
                    type="submit"
                    onClick={(e) => handleSubmit(e)}
                    class="btn btn-primaryb mt-3 addBlogBtn"
                    style={{
                      background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                      color: "#fff",
                    }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div>
              <div className="dateListDiv">
                <h1
                  style={{
                    color: "#ff9c00",
                    fontSize: "25px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    {user?.userData?.name}{" "}
                    <span style={{ fontSize: "80%", color: "#000" }}>
                      ({user?.userData?.email})
                    </span>
                  </div>{" "}
                  {assignedServiceName}
                </h1>
              </div>
            </div>

            <hr />
            <DataTable
              columns={columns}
              data={allData}
              customStyles={customStyles}
              pagination
            />
          </section>
        </div>
      </div>
    </>
  );
};

export default ServicesNotes;
